import { render, staticRenderFns } from "./U8DeliveryOrderReporttable.vue?vue&type=template&id=4cb99add&scoped=true&"
import script from "./U8DeliveryOrderReporttable.vue?vue&type=script&lang=js&"
export * from "./U8DeliveryOrderReporttable.vue?vue&type=script&lang=js&"
import style0 from "./U8DeliveryOrderReporttable.vue?vue&type=style&index=0&id=4cb99add&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb99add",
  null
  
)

export default component.exports